import * as Yup from 'yup';

export const createEditValidationSchema = Yup.object({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  // Optional fields below
  dob: Yup.string().nullable().notRequired(),
  hireDate: Yup.string().nullable().notRequired(),
  rate: Yup.number()
    .typeError('Rate must be a number')
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? undefined : value,
    )
    .nullable()
    .notRequired(),
  payPeriod: Yup.string().nullable().notRequired(),
  mode: Yup.string().nullable().notRequired(),
});
